import { useEffect } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import useDataEvents from './dataHooks/useDataEvents'
import { LoadingIcon } from '@prosolve/common-components-ui'
import useSnackbar from "./hooks/useSnackbar";

import {
  getEnv,
  allowedClientSubdomains,
  getClientSubdomain
} from './utils';

export default () => {
  const { shareCode = '' } = useParams();

  const [ destinationChar, ...codeArray ] = shareCode;
  const code = codeArray.join('');
  
  const [ searchParams ] = useSearchParams();
  const key = searchParams.get('key')
  const keyQS = (key ? `&key=${key}` : '')

  const clientSubdomain = getClientSubdomain()

  const { fetchEventIdByCode } = useDataEvents();

  const snackbar = useSnackbar()

  const showError = (message) => {
    snackbar.newMessage({ message, severity: 'failure' })
  }

  const shareEventRedirect = (eventId) => {
    const urlSubdomain = allowedClientSubdomains.indexOf(clientSubdomain) > -1 ? `${allowedClientSubdomains}.` : '';
    const env = getEnv();
    const url = `https://${urlSubdomain}events.${env ? `${env}.` : ''}prosolve.com/eventView?id=${eventId}`;
    window.open(url, "_self")
  }

  const shareSurveyRedirect = (eventId, assessmentName) => {
    const urlSubdomain = allowedClientSubdomains.indexOf(clientSubdomain) > -1 ? `${allowedClientSubdomains}.` : '';
    const env = getEnv();
    const url =  `https://${urlSubdomain}hub.${env ? `${env}.` : ''}prosolve.com/go/survey?eventId=${eventId}&assessmentName=${assessmentName}`
    window.open(url, "_self")
  }

  const shareScheduleRedirect = (eventId) => {
    const urlSubdomain = allowedClientSubdomains.indexOf(clientSubdomain) > -1 ? `${allowedClientSubdomains}.` : '';
    const env = getEnv();
    const url = `https://${urlSubdomain}events.${env ? `${env}.` : ''}prosolve.com/scheduleView?id=${eventId}${keyQS}`;
    window.open(url, "_self")
  }

  const routeRedirect = (eventData) => {
    const {
      eventId = '',
      assessmentName = '',
      projectAssessmentName = '',
    } = eventData;
    if (destinationChar.toLowerCase() === 'e') {
      if (eventId) {
        shareEventRedirect(eventId)
      } else {
        showError('No event found matching code')
      }
    } else if (destinationChar.toLowerCase() === 's') {
      if (eventId && ( projectAssessmentName || assessmentName )) {
        shareSurveyRedirect(eventId, (projectAssessmentName || assessmentName))
      } else {
        showError('No event or survey found matching code')
      }
    } else if (destinationChar.toLowerCase() === 'm') {
      if (eventId) {
        shareScheduleRedirect(eventId)
      } else {
        showError('No event found matching code')
      }
    } else {
      showError('Invalid destination code provided')
    }
  }

  const fetchEventData = async (code) => {
    try {
      const eventData = await fetchEventIdByCode(code)
      routeRedirect(eventData)
    } catch (e) {
      console.log(e)
      showError('Error occured')
    }
  }

  useEffect(() => {
    if (code) {
      fetchEventData(code)
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [code])

  return (
    <div style={{ 
      display: 'flex',
      justifyContent: 'center',
      marginTop: '50px'
    }}>
      <LoadingIcon />
    </div>
  )
}